module.exports = __webpack_public_path__ + "static/img/loading.2e4cc285.jpg";